import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./kingodomOV3InitialStates";

/**
 * Recordatorio:
 * Hay que tener en cuenta que redux almacena valores inmutables, es decir que no se pueden modificar.
 * Si quisieramos modificar el valor de uno de los valores almacenados en el estado global de redux,
 * tendríamos que actualizar el valor de este. Ejemplo:
 * convocatorias = convocatoriasProcedimientoPCT.map(convo => ({
        ...convo,
        procedencia: 'PCT3'
    }));
    En es este ejemplo se recorre el objeto convocatoria y se le añade la clave valor. Posteriormente habría
    que almacenar el valor en el estado 
 */

const kingdomOV3Slice = createSlice({
    name: 'kingdomOV3',
    initialState,
    reducers: {
        insertNewState: (state, actions) => {
            const { filnedName, value } = actions.payload;
            state[filnedName] = value;
        },
        updatePropertyOfState: (state, action) => {
            const { fieldName, propertyName, propertyValue } = action.payload;
            state[fieldName][propertyName] = propertyValue;
        },
        deleteState(state, action) {
            const { filnedName } = action.payload;
            state[filnedName] = '';
        }
    }
});

export const { insertNewState, updatePropertyOfState, deleteState } = kingdomOV3Slice.actions;

export default kingdomOV3Slice.reducer;